<app-nav titulo="Zonas / Agrupaciones" descripcion="Configuración de zonas y agrupaciones para la calculadora. Cada zona permite sobrescribir parámetros de la configuración base.">
    <div class="zonas">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="zonas"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updatePage($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nueva">
            <mat-icon matPrefix class="add-button-icon">add</mat-icon>
            <span class="add-button-label">Nueva zona</span>
        </button>
    </div>
</app-nav>

<ng-template #activoColumnTemplate let-row="row">
    <span [class]="row.activo ? 'status-badge active' : 'status-badge inactive'">
        {{ row.activo ? 'Activo' : 'Inactivo' }}
    </span>
</ng-template>

<ng-template #actionsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Editar zona" [routerLink]="'./' + row.id + '/editar'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Dar de baja" (click)="deleteZona(row)">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
